var _g;
import * as React from "react";
var SvgButtonStagePlay = function SvgButtonStagePlay(props) {
  return _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#F5F2F0",
    cx: 23,
    cy: 23,
    r: 23
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#262626",
    points: "18 14 31 23 18 32"
  }))));
};
export default SvgButtonStagePlay;